import { Link } from "react-router-dom";
import refresh from "../../assets/icon/refresh.png";

// 계정관리 목록 페이지 상단 탭 바: 새로고침 + "계정 등록" 버튼.
// 서비스 배정이 없는(수퍼관리자) Admin 계정만 사이드바에서 이 페이지로 들어올 수 있다.
export const ComponentTabAccount: React.FC = () => {
  const refetchHandler = () => {
    window.location.href = "/account";
  };

  return (
    <div className="flex flex-wrap justify-between">
      <div className="flex flex-wrap">
        <button
          className="py-3 px-4 relative"
          onClick={() => {
            refetchHandler();
          }}
        >
          <img src={refresh} alt="새로고침" className="w-[30px] h-[30px]" />
        </button>
      </div>
      <div className="flex flex-wrap space-x-2"></div>
      <div className="flex flex-wrap justify-end pr-8">
        <Link
          to={`/account/create`}
          className="bg-transparent bg-[#8b8c8c] w-[104px] h-[30px] py-[7px] text-xs font-bold text-center rounded-lg my-[13px] text-white"
        >
          계정 등록
        </Link>
      </div>
    </div>
  );
};
